import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import LocationsItemForm from "./LocationsItemForm";
import LocationsItemBrowser from "./LocationsItemBrowser";

const LocationsPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="location"
            modeApiName2="locations"
            ItemFormComponent={LocationsItemForm}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            ItemBrowserComponent={LocationsItemBrowser}
        />
    );
};

export default LocationsPage;